// @flow

const OrganizationMemberSSOModeConstants = {
  REQUIRED: "REQUIRED",
  OPTIONAL: "OPTIONAL"
};

export default OrganizationMemberSSOModeConstants;
